import { render } from "./CartLineFieldsTab.vue?vue&type=template&id=2dd5b702"
import script from "./CartLineFieldsTab.vue?vue&type=script&lang=js"
export * from "./CartLineFieldsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__